<template>
	<div class="inner-page managed-cases">
		<AppHead title="Managed cases" />

		<PageHeader 
			title="Managed cases"
			:desc="thisUser.id != $page.props.user.id ? `See which cases are managed by this user.` : `See which cases you are managing.`"
			:hasButton="false"
			:showHelper="true"
			helpTitle="Managed cases"
			helpDesc="Any cases which are managed by this user will be shown below. These are cases where this user has been assigned as the dedicated rep/admin."
			:hr="true"
			/>

		<template v-if="thisUser.id != $page.props.user.id">
			<Subtitle 
				title="The User"
				/>
			<div class="user-info">
				<div class="user-info-item">
					<div class="label">Name</div>
					<div class="value">{{ thisUser.name }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">Email</div>
					<div class="value">{{ thisUser.email }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">User type</div>
					<div class="value">{{ niceRoleName(thisUser.user_type) }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">Team</div>
					<div class="value">
						{{ thisUser.teams && thisUser.teams.length > 0 ? thisUser.teams[0].name : 'N/A' }}
					</div>
				</div>
			</div>
		</template>

		<Subtitle 
			:title="thisUser.id != $page.props.user.id ? `Cases managed by ${thisUser.name}` : 'Cases managed by you'"
			/>

		<template v-if="managedCases && managedCases.length > 0">
			<div class="headers">
				<div class="row">
					<span>Case ID</span>
					<span>Stage</span>
					<span>Status</span>
					<span>Created</span>
				</div>
			</div>
			<ul>
				<li v-for="caseItem in managedCases" :key="caseItem.id">
					<span>
						<Link :href="`/cases/${caseItem.hashid}`">
							{{ caseItem.enquiry_number || caseItem.hashid }}
						</Link>
					</span>
					<span>
						{{ niceStageName(caseItem.progress_stage) }}
					</span>
					<span>
						{{ prettyStatus(caseItem.status) }}
					</span>
					<span>
						{{ niceDate(caseItem.created_at) }}
					</span>
				</li>
			</ul>
		</template>

		<Placeholder 
			v-else
			message="There are no cases managed by this user."
			/>
	</div>
</template>

<script>

import moment from 'moment'
import { Link } from '@inertiajs/inertia-vue3'

import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"

export default {
	layout: AppLayout,
	components: {
		AppHead,
		AppLayout,
		PageHeader,
		Subtitle,
		Placeholder,
		Link
	},
	props: {
		thisUser: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			
		};
	},
	computed: {
		managedCases() {
			return this.thisUser.manages
		}
	},
	methods: {
		niceRoleName(type){
			switch(type){
				case 'admin':
					return 'Super Admin'
					break
				case 'global_viewer':
					return 'Global Viewer'
					break
				case 'team_admin':
					return 'Team Admin'
					break
				case 'team_user':
					return 'Team User'
					break
				case 'viewer':
					return 'Viewer'
					break
				case 'user':
					return 'User'
					break
			}
		},
		niceStageName(stage){
			// You can customize these stage names based on your actual stages
			switch(stage){
				case 0:
					return 'Enquiry Submission'
				case 1:
					return 'Image Submission'
				case 2:
					return 'Design Meeting'
				case 3:
					return 'Treatment Plan'
				case 4:
					return 'Implant Production'
				case 5:
					return 'Post Market Surveillance'
				default:
					return stage ? `Stage ${stage}` : 'N/A'
			}
		},
		prettyStatus(status){
			if(status == 'review'){
				return 'In Review'
			}else if(status == 'pending'){
				return 'Pending Enquiry Upload'
			}else if(status == 'accepted'){
				return 'Accepted'
			}else if(status == 'approved'){
				return 'Approved'
			}else if(status == 'archive'){
				return 'Archived'
			}else if(status == 'rejected'){
				return 'Rejected'
			}
		},
		niceDate(dateString){
			let theDate = new Date(dateString)
			return moment(theDate).format('DD/MM/YYYY')
		},
	},
	mounted() {
		// console.log(this.thisUser)
	}
};
</script>

<style lang="sass">

.managed-cases
	.user-info
		padding: 15px
		border-radius: 8px
		box-shadow: 0 0 10px rgba(0,0,0,0.1)
		background-color: #fff
		display: grid
		grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr))
		gap: 10px
		position: relative
		margin-bottom: 50px

		.user-info-item
			.label
				font-family: 'Roboto Condensed', sans-serif
				font-weight: 700
				font-size: 16px
				line-height: 1.1
				color: #252525
				margin-bottom: 10px

			.value
				font-size: 14px
				font-weight: 400
				
						
	ul
		list-style: none
		padding: 0
		width: 100%
		background-color: #fff
		border-radius: 8px
		box-shadow: 0 1px 3px rgba(#000, 0.12)
		padding: 0 20px
		margin-bottom: 50px

		li
			font-size: 14px
			font-weight: 400
			font-family: 'Roboto', sans-serif
			color: #252525
			line-height: 1.1
			height: 60px
			border-bottom: 1px solid #d0d0d0
			align-items: center
			display: grid
			grid-template-columns: 1fr 1fr 1fr 1fr
			
			&:last-child
				border-bottom: none

			a
				text-decoration: underline
				color: #00d
				transition: all 300ms

				&:hover
					opacity: 0.7

	.headers
		font-size: 18px
		font-weight: 700
		font-family: 'Roboto Condensed', sans-serif
		color: #252525
		line-height: 1.1
		margin-bottom: 10px

		.row
			padding: 0 20px
			display: grid
			grid-template-columns: 1fr 1fr 1fr 1fr
				

</style>
